import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param page
 * @param payload
 * @param sellerId
 * @param productName
 * @param limit
 * @param tenantProductId
 * @param orgId
 * @param productSkuId
 * @param tenantDepartmentId
 * @param tenantId
 */
class ProductService {
  /**
   * @param categoryId
   * @param page
   * @param keyword
   * @param orgId
   * @param mapSkuOffer
   * @param tenantId
   * @param stockStatus
   * @param tenantDepartmentId
   * @param productSkuId
   * @param limit
   * @param productType
   * @param category
   * @param isSalesProduct
   * @param isPurchaseProduct
   * @return {Promise<*>}
   */
  getOrgProducts = async (orgId, tenantId, page, limit, keyword, stockStatus, tenantDepartmentId, productSkuId, productType, category, isSalesProduct, isPurchaseProduct, isArchive, pendingFromVendor, productSkuIds) => {
    let url = `${Constants.TENANT_SKUS}/product_tenants?`;
    if (orgId) url += `org_id=${orgId}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (page) url += `page=${page}&`;
    // if (limit) url += `limit=${limit}&`;
    if (keyword) url += `product_sku_name=${keyword}&`;
    if (stockStatus) url += `stock_status=${stockStatus}&`;
    if (tenantDepartmentId) url += `tenant_department_id=${tenantDepartmentId}&`;
    if (productSkuId) url += `product_sku_id=${productSkuId}&`;
    if (productType) url += `product_type=${productType}&`;
    if (category) url += `product_category_ids=${category}&`;
    if (isSalesProduct) url += `is_sales_product=${isSalesProduct}&`;
    if (isPurchaseProduct) url += `is_purchase_product=${isPurchaseProduct}&`;
    if (isArchive) url += `is_archive=${isArchive}&`;
    if (pendingFromVendor) url += `show_po_pending_qty=${pendingFromVendor}&`;
    if (productSkuIds) {
      url += `product_sku_ids=${productSkuIds}&`;
      const limitCount = productSkuIds.split(',').length;
      url += `limit=${limitCount}&`;
    } else if (limit) url += `limit=${limit}&`;

    const products = await Helpers.get({
      url,
    });
    return products;
  }

  /**
   * @param tenantId
   * @param productSkuId
   * @param tenantDepartmentId
   * @param id
   * @return {Promise<*>}
   */
  getProductsById = async (tenantId, productSkuId, tenantDepartmentId, filterReservedBatches, productSkuIds) => {
    let url = `${Constants.GET_TENANT_SKUS}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (productSkuId) url += `product_sku_id=${productSkuId}&`;
    if (tenantDepartmentId) url += `tenant_department_id=${tenantDepartmentId}&`;
    if (filterReservedBatches === true || filterReservedBatches === false) url += `filter_reserved_quantities=${filterReservedBatches}&`;
    if (productSkuIds) {
      url += `product_sku_ids=${productSkuIds}&`;
      const limit = productSkuIds?.split(',').length;
      url += `limit=${limit}&`;
    }
    url += 'search=true';
    const product = await Helpers.get({
      url,
    });
    return product;
  }

  /**
   * @param keyword
   * @param page
   * @param limit
   * @return {Promise<*>}
   */
  getSearchSuggestions = async (keyword, page, limit) => {
    const searchSuggestions = await Helpers.get({
      url: `https://1nnxtrlxr4.execute-api.ap-south-1.amazonaws.com/prod/searchProducts?query=${keyword}&page=${page}&limit=${limit}&is_active=true`,
    });
    return searchSuggestions;
  }

  /**
   *
   * @param keyword
   * @param page
   * @param limit
   * @return {Promise<*>}
   */
  getSearchResults = async (keyword, page, limit) => {
    const searchSuggestions = await Helpers.get({
      url: `https://1nnxtrlxr4.execute-api.ap-south-1.amazonaws.com/prod/searchProducts?query=${keyword}&page=${page}&limit=${limit}&is_active=true`,
    });
    return searchSuggestions;
  }

  /**
   * @param keyword
   * @param tenantId
   * @param stockStatus
   * @param page
   * @param limit
   * @param tenantDepartmentId
   * @param excludeOutOfStock
   * @param productType
   * @param category
   * @param isSalesProduct
   * @param isPurchaseProduct
   * @param isPurchaseProduct
   * @param isPurchaseProduct
   * @param isShopifyProduct
   * @return {Promise<*>}
   */
  getProducts = async (keyword, tenantId, stockStatus, page, limit, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search = false, sortBy, filterReservedQuantity = false, barcode, isShopifyProduct, isMarketplaceProduct, productSkuIds, departmentId, advanceFilters, isListScreen) => {

    let url = `${Constants.GET_TENANT_SKUS}?`;
    if (keyword) url += `product_sku_name=${keyword}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (stockStatus) url += `stock_status=${stockStatus}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    if (tenantDepartmentId) url += `tenant_department_id=${tenantDepartmentId}&`;
    if (excludeOutOfStock) url += `exclude_out_of_stock=${excludeOutOfStock}&`;
    if (productType) url += `product_type=${productType}&`;
    if (category) url += `product_category_ids=${category}&`;
    if (isSalesProduct) url += `is_sales_product=${isSalesProduct}&`;
    if (isPurchaseProduct) url += `is_purchase_product=${isPurchaseProduct}&`;
    if (sortBy) url += `order_by=${sortBy}&`;
    if (search) url += `search=${true}&`;
    if (filterReservedQuantity) url += 'filter_reserved_quantities=true&';
    if (barcode) url += `barcode=${barcode}&`;
    if (isShopifyProduct) url += `is_shopify_product=${isShopifyProduct}&`;
    if (isMarketplaceProduct) url += `is_marketplace_product=${isMarketplaceProduct}&`;
    if (productSkuIds) url += `product_sku_ids=${productSkuIds}&`;
    if (departmentId) url += `department_id=${departmentId}&`;
    if (advanceFilters) url += `advanced_filter=${advanceFilters}&`;
    if (isListScreen) url += `is_list=${isListScreen}&`;
    const products = await Helpers.get({ url });
    return products;
  }

  /**
   *
   * @param {*} page
   * @param {*} tenantId
   * @return
   */
  getLowOrgProducts = async (page, tenantId) => {
    const lowRunningProducts = await Helpers.get({
      url: `${Constants.GET_LOW_ORG_PRODUCTS}?page=${page}&limit=10${tenantId ? `&tenant_id=${tenantId}` : ''}`,
    });
    return lowRunningProducts;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  addProductVendor = async (payload) => {
    const productVendor = await Helpers.post({
      url: Constants.OFFERS,
      data: payload,
    });
    return productVendor;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  addProductToInventory = async (payload) => {
    const addedProduct = await Helpers.post({
      url: Constants.TENANT_SKUS,
      data: payload,
    });
    return addedProduct;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  updateIndentStatus = async (payload) => {
    const addedProduct = await Helpers.put({
      url: Constants.UPDATE_INDENT_STATUS,
      data: payload,
    });
    return addedProduct;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  createIndent = async (payload) => {
    const addedProduct = await Helpers.post({
      url: Constants.CREATE_INDENT,
      data: payload,
    });
    return addedProduct;
  }

  /**
   *
   * @param {*} payload
   * @return
   */
  updateIndent = async (payload) => {
    const indent = await Helpers.put({
      url: Constants.UPDATE_INDENT,
      data: payload,
    });
    return indent;
  }

  /**
   * @param {*} page
   * @param {*} tenantId
   * @param indentId
   * @param adjustmentEntityType
   * @param searchKeyword
   * @return
   */
  getIndent = async (page, tenantId, indentId, adjustmentEntityType, searchKeyword, department, limit) => {
    let url = `${Constants.GET_INDENT}?`;
    if (page) url += `page=${page}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (indentId) url += `ia_id=${indentId}&`;
    if (adjustmentEntityType) url += `adjustment_reason=${adjustmentEntityType}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (department) url += `department_id=${department}&`;
    if (limit) url += `limit=${limit}&`;

    const indent = await Helpers.get({ url });
    return indent;
  };

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  updateProductToInventory = async (payload) => {
    const addedProduct = await Helpers.put({
      url: Constants.TENANT_SKUS,
      data: payload,
    });
    return addedProduct;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  setDefaultOffer = async (payload) => {
    const defaultOffer = await Helpers.put({
      url: Constants.SET_DEFAULT_OFFER,
      data: payload,
    });
    return defaultOffer;
  }

  /**
   *
   * @param tenantId
   * @param sellerId
   * @param productName
   * @param page
   * @param limit
   * @return {Promise<*>}
   */
  getSellerProducts = async (tenantId, sellerId, productName, page, limit) => {
    let url = `${Constants.GET_SELLER_PRODUCTS}?`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (sellerId) url += `seller_id=${sellerId}&`;
    if (productName) url += `product_sku_name=${productName}&`;
    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}`;
    const sellerProducts = await Helpers.get({ url });
    return sellerProducts;
  }

  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  deleteIndent = async (payload) => {
    const deleteIndent = await Helpers.delete({
      url: Constants.CREATE_INDENT,
      data: payload,
    });
    return deleteIndent;
  }

  getRecentTransactions = async (tenantId, productSkuId, sellerId, rangeDays, customerId, typeOfTransaction) => {
    let url;
    if (typeOfTransaction === 'PURCHASE_ORDER') {
      url = `${Constants.METRICS}/purchase_historical_prices?`;
    } else if (typeOfTransaction === 'SALES_ORDER') {
      url = `${Constants.METRICS}/sales_historical_prices?`;
    } else {
      url = `${Constants.METRICS}/purchase_historical_prices?`;
    }

    if (productSkuId) url += `product_sku_id=${productSkuId}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (sellerId) url += `seller_id=${sellerId}&`;
    if (rangeDays) url += `range_days=${rangeDays}&`;
    if (customerId) url += `customer_id=${customerId}&`;
    const recentTxns = await Helpers.get({
      url,
    });
    return recentTxns;
  }

  getInventoryLogs = async (tenantId, orgId, tenantProductId, productSkuId, page, limit, tenantDepartmentId, startDate, endDate, searchKeyword) => {
    let url = `${Constants.INVENTORY_LOGS}?`;
    if (tenantProductId) url += `tenant_product_id=${tenantProductId}&`;
    if (productSkuId) url += `product_sku_id=${productSkuId}&`;
    if (tenantId) url += `tenant_id=${tenantId}&`;
    if (orgId) url += `org_id=${orgId}&`;
    if (tenantDepartmentId) url += `tenant_department_id=${tenantDepartmentId}&`;
    if (startDate) url += `from_date=${startDate}&`;
    if (endDate) url += `to_date=${endDate}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;

    if (page) url += `page=${page}&`;
    if (limit) url += `limit=${limit}&`;
    const products = await Helpers.get({
      url,
    });
    return products;
  }

  getProductBySkus = async (payload) => {
    const getProducts = await Helpers.post({
      url: Constants.GET_SKUS_CODES,
      data: payload,
    });
    return getProducts;
  }

  getSellerCodes = async (sellerCode, orgId) => {
    let url = `${Constants.GET_SELLER_CODES}?`;
    if (sellerCode) url += `slr_code=${sellerCode}&`;
    if (orgId) url += `org_id=${orgId}&`;
    const slrData = await Helpers.get({
      url,
    });
    return slrData;
  }

  /**
   *
   * @param payload
   * @returns {Promise<*>}
   */
  printBarcodes = async (payload) => {
    const url = `${Constants.BASE_URL}/barcode/print`;
    const product = await Helpers.post({
      url,
      data: payload,
    });
    return product;
  }

  getProductBySkus = async (payload) => {
    const getProducts = await Helpers.post({
      url: Constants.GET_SKUS_CODES,
      data: payload,
    });
    return getProducts;
  }

  getSellerCodes = async (sellerCode, orgId) => {
    let url = `${Constants.GET_SELLER_CODES}?`;
    if (sellerCode) url += `slr_code=${sellerCode}&`;
    if (orgId) url += `org_id=${orgId}&`;
    const slrData = await Helpers.get({
      url,
    });
    return slrData;
  }

  /**
   *
   * @param payload
   * @returns {Promise<*>}
   */
  printBarcodes = async (payload) => {
    const url = `${Constants.BASE_URL}/barcode/print`;
    const product = await Helpers.post({
      url,
      data: payload,
    });
    return product;
  }

  updateSAWorkflowStep = async (payload) => {
    const workflowStep = await Helpers.post({
      url: `${Constants.GET_INDENT}/work_flow`,
      data: payload,
    });
    return workflowStep;
  }

  // Download Product Batches List
  downloadProductBatchesList = async (payload) => {
    const url = `${Constants.DOWNLOAD_PRODUCT_BATCHES_LIST}`;
    const productBatches = await Helpers.post({
      url,
      data: payload,
    });
    return productBatches;
  }

  // Download inventory logs
  downloadInventoryLogs = async (payload) => {
    const url = `${Constants.DOWNLOAD_INVENTORY_LOGS}`;
    const inventoryLogs = await Helpers.post({
      url,
      data: payload,
    });
    return inventoryLogs;
  }

  /**
   *
   * @param payload
   * @returns {Promise<*>}
   */
  bulkUpdateProducts = async (payload) => {
    const url = `${Constants.TENANT_SKUS}/bulk`;
    const bulkUpdate = await Helpers.put({
      url,
      data: payload,
    });
    return bulkUpdate;
  }

  /**
   *
   * @returns {Promise<*>}
   */
  getBulkUploadMetadata = async () => {
    const url = `${Constants.TENANT_SKUS}/bulk_upload/v2/metadata`;
    const bulkUpdate = await Helpers.get({
      url,
    });
    return bulkUpdate;
  }

  /**
   *
   * @param payload
   * @returns {Promise<*>}
   */
  bulkUploadProducts = async (payload) => {
    const url = `${Constants.TENANT_SKUS}/bulk_upload/v2`;
    const data = new FormData();
    data.append('file', payload?.file);
    data.append('column_mapping', JSON.stringify(payload?.columnMapping));
    data.append('tax_mapping', JSON.stringify(payload?.taxMapping));
    data.append('uom_mapping', JSON.stringify(payload?.uomMapping));
    data.append('tenant_ids', payload?.tenants);

    const bulkUpload = await Helpers.filePost({
      url,
      file: data,
    });
    return bulkUpload;
  }

  productsBulkUpdate = async (payload) => {
    const url = `${Constants.TENANT_SKUS}/bulk_update`;
    const data = new FormData();
    data.append('file', payload?.file);
    data.append('column_mapping', JSON.stringify(payload?.columnMapping));
    data.append('tax_mapping', JSON.stringify(payload?.taxMapping));
    data.append('uom_mapping', JSON.stringify(payload?.uomMapping));
    data.append('tenant_id', payload?.tenants);
    data.append('current_tenant_id', payload.current_tenant_id);

    const bulkUpdate = await Helpers.filePost({
      url,
      file: data,
    });
    return bulkUpdate;
  }

  getTallyProducts = async (itId, orgId, searchKeyword, selectedProduct) => {
    let url = `${Constants.GET_TALLY_PRODUCTS}?`;
    if (itId) url += `it_id=${itId}&`;
    if (orgId) url += `org_id=${orgId}&`;
    if (searchKeyword) url += `search_keyword=${searchKeyword}&`;
    if (selectedProduct) url += `selected_tally_product_id=${selectedProduct}&`;
    const getTallyProducts = await Helpers.get({ url });
    return getTallyProducts;
  }
}
export default new ProductService();
